import { DropdownWithLabel } from '@blueprint/dropdown';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';
import { buildSelectBedsTitle } from '@zoopla/redux-reducer-filters';
import { DropdownContainer } from '../DropdownContainer';

const translationsMap = new Map([
    ['studio', 'studio'],
    ['studios', 'studios'],
    ['bed', 'bed'],
    ['beds', 'beds'],
    ['min', 'min'],
    ['max', 'max'],
    ['default', 'Any beds']
]);

const beds = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const bedsOptions = [
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10+' }
];

export type BedsMin = typeof beds[number];
export type BedsMax = typeof beds[number];

type SelectBedsProps = {
    value: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    };
    onChange: ({
        bedsMin,
        bedsMax
    }: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    }) => void;
};

export const SelectBeds = ({ value, onChange }: SelectBedsProps) => {
    const dropdownTitle = buildSelectBedsTitle(
        parseInt(value.bedsMin, 10),
        parseInt(value.bedsMax, 10),
        translationsMap
    );

    const bedroomsLabel = 'Bedrooms';
    const minBedsLabelText = 'Minimum beds';
    const maxBedsLabelText = 'Maximum beds';

    const bedsMinOptions =
        value.bedsMax !== ''
            ? bedsOptions.slice(0, Number(value.bedsMax) + 1)
            : bedsOptions;

    const bedsMaxOptions =
        value.bedsMin !== ''
            ? bedsOptions.slice(Number(value.bedsMin))
            : bedsOptions;

    return (
        <MultiColumnDropdownWithLabel
            id="AnyBeds_testId"
            title={dropdownTitle}
            testId="AnyBeds_testId"
            label={bedroomsLabel}
        >
            <DropdownContainer>
                <DropdownWithLabel
                    id="beds_min"
                    onChange={(e) => {
                        onChange({
                            ...value,
                            bedsMin: e.target.value
                        });
                    }}
                    value={value.bedsMin}
                    name="beds_min"
                    hasBorderRadius
                    aria-label="Minimum Beds"
                    data-testid="min_beds_testid"
                    label={minBedsLabelText}
                >
                    <option value="">No min</option>
                    {bedsMinOptions.map((bedsMinOption, index) => {
                        return (
                            <option
                                value={bedsMinOption.value}
                                key={`quicksearch_beds_mins_${index}`}
                            >
                                {bedsMinOption.text}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
            <DropdownContainer>
                <DropdownWithLabel
                    id="beds_max"
                    onChange={(e) => {
                        onChange({
                            ...value,
                            bedsMax: e.target.value
                        });
                    }}
                    value={value.bedsMax}
                    hasBorderRadius
                    name="beds_max"
                    aria-label="Maximum Beds"
                    data-testid="max_beds_testid"
                    label={maxBedsLabelText}
                >
                    <option value="">No max</option>
                    {bedsMaxOptions.map((bedsMaxOption, index) => {
                        return (
                            <option
                                value={bedsMaxOption.value}
                                key={`quicksearch_beds_max_${index}`}
                            >
                                {bedsMaxOption.text}
                            </option>
                        );
                    })}
                </DropdownWithLabel>
            </DropdownContainer>
        </MultiColumnDropdownWithLabel>
    );
};
